import { css } from 'linaria';

export const wrapper = css`
    position: relative;
    overflow: hidden;
`;

export const image = css`
    width: 100%;
    height: 100%;
    max-width: 100%;
    display: block;
    text-indent: -9999px;
    position: absolute;
    top: 0;
    left: 0;
`;

export const fallback = css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const fitVariants = {
    cover: css`
        object-fit: cover;
    `,
    contain: css`
        object-fit: contain;
    `,
    'scale-down': css`
        object-fit: scale-down;
    `,
};

export const fullHeight = css`
    height: 100%;
    height: -webkit-fill-available;
`;

export const fullWidth = css`
    width: 100%;
`;
